import React, { useEffect } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import useGlobalModel from './model/globalModel'
import { Login } from './views/login/Login'
import Index from './layout'
import { setToken } from './utils/constants'
import TokenLogin from './views/login/TokenLogin'
import { urlParse } from '@/utils/utils'

function App() {
    const {
        user: { token },
        requestCacheAll,
    } = useGlobalModel(({ user }) => [user])

    useEffect(() => {
        if (token) {
            requestCacheAll()
        }
    }, [token, requestCacheAll]) // 修复：添加 requestCacheAll 到依赖数组

    function loginCheck() {
        const url = window.location.href
        let urlObj = urlParse(url)

        if (urlObj.token) {
            setToken(urlObj.token)
            return <TokenLogin token={urlObj.token} />
        }
        return <Login />
    }

    return (
        <Switch>
            <Route path="/login" component={() => loginCheck()} />
            <Route path="/" render={() => (token ? <Index /> : <Redirect to="/login" />)} />
        </Switch>
    )
}

export default App
